import compress from '@components/form/photos/functions/asyncFileCompressInBrowser'
import { constructAuthHeader } from '@api/apiFetcher'

const PROXY = process.env.NEXT_PUBLIC_IMAGE_SERVICE
const API = `${PROXY}/temp/upload`
const UPLOAD_NAME = 'tempFile'

const createHandler =
    (refs) =>
        (handler) =>
            (event) => handler({ ...refs, event })

const STATE = {
    uploadsInProgress: 0,
    lastProgress: 0,
    progressById: {},
}

const createFilePreloadToServer =
    (authToken, setProgress) =>
        (file) => {
            if (isValidForUpload(file)) {
                try {
                    const { id } = file

                    const handle = createHandler({ file, setProgress })
                    const onProgress = handle(progressHandler)
                    const onError = handle(errorHandler)
                    const onLoad = handle(completeHandler)
                    const onAbort = handle(abortHandler)

                    const XR = new XMLHttpRequest()
                    XR.upload.addEventListener('progress', onProgress, false)
                    XR.addEventListener('error', onError, false)
                    XR.addEventListener('load', onLoad, false)
                    XR.addEventListener('abort', onAbort, false)
                    initalizeUploadState(file, setProgress)

                    compress(file)
                        .then(compressed => {
                            // console.log(`${Math.round((file.size - compressed.size) / 1024)} Kb gained via compression.`)
                            const formData = new FormData()
                            formData.append(UPLOAD_NAME, file, id)
                            XR.open('POST', API)
                            if (authToken) XR.setRequestHeader(...constructAuthHeader(authToken))
                            XR.send(formData)
                        })

                } catch (err) {
                    console.log(err)
                }
            }

            return file
        }

function isValidForUpload (file) {
    return file?.id
        && file.size
        && file.type
        && !file.uploaded
}

function progressHandler ({ file: { id }, event: { loaded, total }, setProgress }) {
    const percent = Math.round(loaded / total * 100)
    updateUploadState(id, percent, setProgress)
}

function errorHandler ({ file: { id }, setProgress }) {
    discardUploadState(id, setProgress)
    throw new Error('Nie udało się przesłać pliku', id)
}

function completeHandler ({ file, file: { id }, event: { target: { responseText }}, setProgress }) {
    discardUploadState(id, setProgress, true)
    file.uploaded = true
}

function abortHandler ({ file: { id }, setProgress }) {
    discardUploadState(id, setProgress)
}

function initalizeUploadState (file, setProgress) {
    const { id } = file
    STATE.uploadsInProgress++
    STATE.progressById[id] = 0

    if (setProgress) setProgress(0)
}

function updateUploadState (id, percent, setProgress) {
    STATE.progressById[id] = percent || 0

    const totalUploads = STATE.uploadsInProgress
    const totalPercentage = Object
        .keys(STATE.progressById)
        .reduce((acc, key) => acc + STATE.progressById[key], 0)
    const averagePercent = Math.round(totalPercentage / totalUploads)

    const progression = Math.abs(averagePercent - STATE.lastProgress)
    if (progression >= 5 && averagePercent > STATE.lastProgress) {
        STATE.lastProgress = averagePercent
        if (setProgress) setProgress(averagePercent)
    }
}

function discardUploadState (id, setProgress, done) {
    STATE.uploadsInProgress--
    if (STATE.progressById[id] != null) delete STATE.progressById[id]
    if (setProgress && STATE.uploadsInProgress === 0) {
        STATE.lastProgress = 0
        setProgress(100, done)
        setTimeout(() => setProgress(null), 250)
    }
}

export default createFilePreloadToServer